import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumDocumentFileType implements BaseEnumType {
  private static allValues: EnumDocumentFileType[] = []; // make sure this is top-most
  
  public static pdf = new EnumDocumentFileType(0, "Pdf", "enum_document_file_type_pdf");
  public static docx = new EnumDocumentFileType(1, "Docx", "enum_document_file_type_docx");
  public static png = new EnumDocumentFileType(2, "Png", "enum_document_file_type_png");
  public static jpeg = new EnumDocumentFileType(3, "Jpeg", "enum_document_file_type_jpeg");
  public static csv = new EnumDocumentFileType(4, "Csv", "enum_document_file_type_csv");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumDocumentFileType.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isPdf() { return this === EnumDocumentFileType.pdf; }
  public isDocx() { return this === EnumDocumentFileType.docx; }
  public isPng() { return this === EnumDocumentFileType.png; }
  public isJpeg() { return this === EnumDocumentFileType.jpeg; }
  public isCsv() { return this === EnumDocumentFileType.csv; }

  public static getValues(): readonly EnumDocumentFileType[] {
    return EnumDocumentFileType.allValues;
  }

  public static getValuesExcept0(): readonly EnumDocumentFileType[] {
    return EnumDocumentFileType.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumDocumentFileType {
    const found = EnumDocumentFileType.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumDocumentFileType - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumDocumentFileType): EnumDocumentFileType {
    const found = name ? EnumDocumentFileType.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumDocumentFileType - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumDocumentFileType>): boolean {
    return this.key === other?.key;
  }
}